export function fbEvent(name, options = {}) {
  window.fbq('track', name, options)
}

export function fbCustomEvent(name, options = {}) {
  window.fbq('trackCustom', name, options)
}
